<template>
    <div>
        <div class="">

            <div class="">
                <div class="d-flex justify-content-around">
                    <div>
                        <h4>Find Pools By Name</h4>
                        <b-form-input v-model="searchText" placeholder="Search by name" @input="currentPage=1"></b-form-input>
                    </div>
                    <div>
                        <h4>Sort By</h4>
                        <b-form-select v-model="sortBy" :options="sortOptions"></b-form-select>
                    </div>
                    <div>
                        <h4>Sort Direction</h4>
                        <b-form-select v-model="sortDesc" :options="sortDirectionOptions"></b-form-select>
                    </div>
                    <!--            <h4>Find By Tag</h4>
                                <el-select v-model="selectedFlags" multiple filterable placeholder="Please select">
                                    <el-option
                                            v-for="item in flags"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>-->
                </div>
            </div>
        </div>
        <b-table responsive :items="filteredPools"
                 :fields="[
                    { key: 'name', label: 'Name', sortable: true },
                    { key: 'count', label: '# Of Pools', sortable: true },

                    { key: 'tvl', label: 'TVL', sortable: true },
                    { key: 'max', label: '365d Yield', sortable: true },
                    { key: 'volume', label: '24hr Volume', sortable: true },
                    { key: 'fees', label: '24hr Fees', sortable: true },
                    { key: 'details', label: 'Details' },

                ]"
                 class="font-weight-normal  table-sm table-hover small "
                 td-class="align-middle"
                 :per-page="perPage"
                 :current-page="currentPage"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 card small

        >
            <template v-slot:cell(rank)="data">
                <span class="text-success">{{ data.item.rank }}</span>
            </template>
            <template v-slot:cell(name)="data">
                <img :src="data.item.pools[0].token_a_logoURI" class="brround" style="width: 25px; height: 25px; ">
                <img :src="data.item.pools[0].token_b_logoURI" class="brround" style="width: 25px; height: 25px; margin-left:-5px">
                {{ data.item.name }}
            </template>

            <template v-slot:cell(tvl)="data">
                ${{ Math.floor(data.item.tvl).toLocaleString() }}
            </template>
            <template v-slot:cell(max)="data">
                {{ (data.item.min).toFixed(1) }} -
                {{ (data.item.max).toFixed(1) }}%
            </template>
            <template v-slot:cell(volume)="data">
                ${{ Math.floor(data.item.volume).toLocaleString() }}
            </template>
            <template v-slot:cell(fees)="data">
                ${{ Math.floor(data.item.fees).toLocaleString() }}
            </template>
            <template v-slot:cell(details)="data">
                <button @click="data.toggleDetails" class="btn btn-outline-success btn-sm">Show Pools</button>
            </template>
            <template #row-details="data">
                <b-card>
                    <b-table responsive :items="data.item.pools"
                             :fields="[
                            { key: 'name', label: 'Name', sortable: true },
                            { key: 'platform', label: 'Platform', sortable: true },
                            { key: 'tvl', label: 'TVL', sortable: true },
                            { key: 'volume_24h', label: '24h Volume', sortable: true },
                            { key: 'fees_24h', label: '24hr Fees', sortable: true },
                            { key: 'apy', label: '365d Yield', sortable: true },
                            { key: 'fee_bps', label: 'LP Fee', sortable: true },
                            { key: 'details', label: 'Details' },
                        ]"
                             class="font-weight-normal  table-sm table-hover small"
                             td-class="align-middle"
                             :sort-by="sortByDetails"
                             :sort-desc="sortDetailsDesc"
                             card small

                    >
                        <template v-slot:cell(name)="data">

                            <img :src="data.item.token_a_logoURI" :alt="data.item.token_a_symbol" class="brround" style="width: 25px; height: 25px; ">
                            <img :src="data.item.token_b_logoURI" :alt="data.item.token_b_symbol" class="brround" style="width: 25px; height: 25px; margin-left:-5px; margin-right:10px">

                            {{ data.item.name }}
                        </template>
                        <template v-slot:cell(platform)="data">
                            <small>
                                {{ data.item.platform }}
                            </small>
                        </template>
                        <template v-slot:cell(tvl)="data">
                            ${{ Math.floor(data.item.tvl).toLocaleString() }}
                        </template>
                        <template v-slot:cell(volume_24h)="data">
                            ${{ Math.floor(data.item.volume_24h).toLocaleString() }}
                        </template>
                        <template v-slot:cell(fees_24h)="data">
                            ${{ Math.floor(data.item.fees_24h).toLocaleString() }}
                        </template>
                        <template v-slot:cell(apy)="data">
                            {{ (data.item.internal_yield).toFixed(2) }}%
                        </template>
                        <template v-slot:cell(fee_bps)="data">
                            {{ (data.item.fee_bps/100).toFixed(2) }}%
                        </template>

                        <template v-slot:cell(details)="data">
                            <a :href="data.item.pool_link" target="_blank" class="btn btn-outline-success btn-sm">View LP</a>
                        </template>
                    </b-table>
                </b-card>

            </template>
        </b-table>
        <b-pagination v-model="currentPage" :total-rows="filteredPools.length" :per-page="perPage" class="my-0" aria-controls="my-table"></b-pagination>
    </div>
</template>

<script>
export default {
    name: "LiquidityPools",
    data() {
        return {
            perPage: 50,
            currentPage: 1,
            sortBy: 'volume',
            sortDesc: true,
            sortByDetails: 'volume_24h',
            sortDetailsDesc: true,
            searchText:'',
            pools: [],
            selectedTags: [],
            flags: [
                /*  'excessive_commission', //danger
        'zero_commission',
        'low_software_version',
        'low_published_information',
        'high_stake_concentration',
        'high_data_center_concentration',
        'extreme_data_center_concentration',
        'delinquent',
        "SLOW_VOTER",
        "BLACKLIST_COMMISSION_RUG",
        'high_commission' // warning
        */

            ],
            sortOptions: [
                {value: 'name', text: 'Name'},
                {value: 'max', text: 'Yield'},
                {value: 'tvl', text: 'TVL'},
                {value: 'volume', text: 'Volume'},
                {value: 'fees', text: 'Fees'},
                {value: 'volume', text: '# of Pools'},

            ],
            sortDirectionOptions: [
                {value: true, text: 'Descending'},
                {value: false, text: 'Ascending'},
            ]
        }
    },
    mounted() {
        this.getPools()
    },
    computed: {
        filteredPools() {
            let filteredPools = this.pools
            if (this.searchText) {
                filteredPools = filteredPools.filter(validator => {
                    let name = (validator.name || '').toLowerCase() + ' ' + (validator.platform || '').toLowerCase()
                    return name.toLowerCase().includes(this.searchText.toLowerCase())
                })

            }
            return filteredPools
        }
    },
    methods: {
        onSortChange({ sortBy, sortDesc }) {
            this.sortBy = sortBy
            this.sortDesc = sortDesc
        },
        async getPools() {
            this.pools = (await axios.get('/defi/pools')).data.map(pool => {
                return { ...pool, _showDetails: false };
            })
            console.log(this.pools)
        }
    }
}
</script>

<style scoped>

</style>
